export function TrendLineUp(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.456 3.46656V5.54743C11.456 5.8056 11.2386 6.014 10.9693 6.014C10.7 6.014 10.4826 5.8056 10.4826 5.54743V4.55365L7.28668 7.61742C7.10336 7.79316 6.78052 7.79316 6.59721 7.61742L4.63748 5.73872L1.3783 8.86314C1.28258 8.9549 1.15767 9 1.03437 9C0.909457 9 0.784541 8.9549 0.690448 8.86314C0.499017 8.68118 0.499017 8.38569 0.690448 8.20373L4.29355 4.74806C4.47525 4.57387 4.79971 4.57387 4.98141 4.74806L6.94113 6.62831L9.75256 3.93313H8.79865C8.53098 3.93313 8.31197 3.72473 8.31197 3.46656C8.31197 3.2084 8.53098 3 8.79865 3H10.9693C11.2386 3 11.456 3.2084 11.456 3.46656Z"
        fill="#1FC16B"
      />
    </svg>
  );
}
